// Tek source of truth: 60 maskot için yol + helper'lar.
// Kullanım: import { M, getKarakterForCategory, dailyKarakter } from './utils/maskot';

const BASE = '/maskotlar';

export const MOD_NAMES = ['merhaba', 'thinking', 'excited', 'sad', 'surprised'];
export const ROL_NAMES = ['veli', 'ogretmen', 'mudur', 'ogrenci', 'yonetici'];
// Mascot dosya isimleri — disk üzerinde paket-baslangic.webp vs. dosyaları
// hala mevcut (rename etmedik). Yeni plan id'lerine map.
export const PAKET_NAMES = ['ucretsiz', 'premium', 'okulbot', 'kurumsal'];

// Disk dosya adları (geriye dönük): paket-baslangic.webp vb.
// Yeni id → eski dosya adı mapping
export const PAKET_FILE_MAP = {
  ucretsiz: 'baslangic',
  premium:  'standart',
  okulbot:  'profesyonel',
  kurumsal: 'kurumsal',
};
export const KARAKTER_NAMES = [
  'ai-chatbot', 'ai-goru', 'ai-kodlayici', 'ai-prompt-muhendisi', 'aile',
  'asci', 'astronot', 'balikci', 'bilim-insani', 'cambaz',
  'cerrah', 'ciftci', 'dalgic', 'dansci', 'dedektif',
  'denizci', 'dis-hekimi', 'doktor', 'fotografci', 'gazeteci',
  'hakem', 'hakim', 'hemsire', 'itfaiyeci', 'kaleci',
  'kasif', 'korsan', 'kovboy', 'kutuphaneci', 'muhendis',
  'muzisyen', 'ninja', 'oyuncu', 'palyaco', 'peri',
  'pilot', 'pizzaci', 'polis', 'ressam', 'sihirbaz',
  'sovalye', 'sporcu', 'super-kahraman', 'veteriner', 'yazilimci',
  'yogaci',
];

export const M = {
  mod:    (k) => `${BASE}/mod-${k}.webp`,
  rol:    (k) => `${BASE}/rol-${k}.webp`,
  paket:  (k) => `${BASE}/paket-${PAKET_FILE_MAP[k] || k}.webp`,
  kar:    (k) => `${BASE}/okulbot-${k}.webp`,
};

// ── Random / daily seçimler ─────────────────────────────────────────
export function randomKarakter() {
  return KARAKTER_NAMES[Math.floor(Math.random() * KARAKTER_NAMES.length)];
}

export function dailyKarakter() {
  // Gün/ay/yıl deterministik seed — aynı gün aynı maskot
  const d = new Date();
  const seed = d.getFullYear() * 1000 + (d.getMonth() + 1) * 31 + d.getDate();
  return KARAKTER_NAMES[seed % KARAKTER_NAMES.length];
}

// ── Kategori → maskot eşleşmesi ──────────────────────────────────────
// CATS keys: anaokul, oyunevi, kurs, ozel, spor, muzik
// Bazı kategoriler rol-* maskotu kullanıyor (örn. anaokul → rol-ogrenci)
const CAT_MASKOT = {
  anaokul:    { type: 'rol', name: 'ogrenci' },
  kres:       { type: 'kar', name: 'aile' },
  oyunevi:    { type: 'kar', name: 'oyuncu' },
  kurs:       { type: 'kar', name: 'kasif' },
  ozel:       { type: 'kar', name: 'dedektif' },
  spor:       { type: 'kar', name: 'sporcu' },
  muzik:      { type: 'kar', name: 'muzisyen' },
  sanat:      { type: 'kar', name: 'ressam' },
  dans:       { type: 'kar', name: 'dansci' },
  bilim:      { type: 'kar', name: 'bilim-insani' },
  yazilim:    { type: 'kar', name: 'yazilimci' },
  yemek:      { type: 'kar', name: 'asci' },
  yaz_kampi:  { type: 'kar', name: 'astronot' },
  dil:        { type: 'kar', name: 'gazeteci' },
};

// {type, name} dönen yeni helper — type rol/kar/mod/paket olabilir
export function getMaskotForCategory(cat) {
  if (!cat) return { type: 'kar', name: 'aile' };
  return CAT_MASKOT[cat] || { type: 'kar', name: 'aile' };
}

// Geriye dönük uyum (sadece karakter ismi döner — yalnızca kar tipinde anlamlı)
export function getKarakterForCategory(cat) {
  const m = getMaskotForCategory(cat);
  return m.type === 'kar' ? m.name : 'aile';
}

// ── Rol context helper'ları (auth/profile/onboarding için) ──────────
export function getRolForUser(user) {
  // Kullanıcı metadatasında rol varsa onu, yoksa default 'veli'
  return user?.user_metadata?.role || 'veli';
}

// ── Mod state helper'ı (Maskot durumları / mod adları) ──────────────────────────
export function getModForState(state) {
  switch (state) {
    case 'loading':
    case 'thinking':
    case 'typing':
      return 'thinking';
    case 'error':
    case 'failed':
    case 'empty':
      return 'sad';
    case 'success':
    case 'celebrate':
      return 'excited';
    case 'surprise':
    case 'new':
      return 'surprised';
    case 'idle':
    case 'merhaba':
    case 'welcome':
    default:
      return 'merhaba';
  }
}
